import { toast } from "react-toastify";
import { memberIdLabel } from "../../../shared/memberType";
import useAuth from "../../../shared/hooks/useAuth";
import "./MemberIdTag.scss";

interface IMemberIdTagProps {
  memberId?: string;
  memberType?: string;
}

/**
 * "(1555 - V)" for admins, "(1555)" for everyone else.
 *
 * The member-type code is internal shorthand and is not for members to see, so
 * the check lives here rather than at the call sites — several of these popups
 * are shared between admins and members, and a caller that forgot would leak
 * the code rather than merely hide it.
 *
 * Admins read ids off these screens constantly to paste elsewhere, so the whole
 * tag is the copy target. Only the id is copied, never the code.
 */
function MemberIdTag(props: IMemberIdTagProps) {
  const { memberId, memberType } = props;
  const { isAdmin } = useAuth();
  if (!memberId) return null;

  const copy = async (event: React.MouseEvent) => {
    // These tags sit inside rows that open popups on click.
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(memberId);
      toast.success("Medlemmens ID har kopierats!");
    } catch {
      // Clipboard access needs a secure context; it is not available over
      // plain http, which includes some local setups.
      toast.error("Kunde inte kopiera ID:t");
    }
  };

  return (
    <span
      className="member-id-tag pointer"
      onClick={copy}
      title="Kopiera medlems-ID"
    >
      ({memberIdLabel(memberId, isAdmin ? memberType : undefined)})
    </span>
  );
}

export default MemberIdTag;
